import { render, staticRenderFns } from "./CourseWare.vue?vue&type=template&id=545916c1&scoped=true&"
import script from "./CourseWare.vue?vue&type=script&lang=js&"
export * from "./CourseWare.vue?vue&type=script&lang=js&"
import style0 from "./CourseWare.vue?vue&type=style&index=0&id=545916c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545916c1",
  null
  
)

export default component.exports